

var ACQ_Banner_Type = 'acquisition';
define(['angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/fi/index', 'components/xo-beaver/dist/logger'], function (angular, squid, template) {

    squid.module('xo-offer.directive', ['squid', 'xomodel.checkout']).directive('xoOffer', function () {
        return {
            template: template,

            scope: {
                token: '=',
                promotion: '=',
                bmlaction: '=',
                installment: '=',
                selectedmethod: '=',
                reusetext: '='
            },

            controller: function controller($scope, $sce, $FallbackError, $populate, $state, $q, $CheckoutSessionModel, $CheckoutAppDataModel, $CheckoutCartModel, $pxp, $logger, $InstallmentOptionsModel, $feature, $locale, $CheckoutPayeeModel, $util, $CreditDataModel, $CreditOptionsModel, $config, $rootScope, $MarketingOfferModel, $fireMORSBeacon, $AuthModel, $CreditInstallmentModel) {
                var isCreditInWallet = void 0;
                var isRedirectFromCape = void 0;

                var BANNER_TYPES = {
                    'PASSIVE': 'PASSIVE',
                    'PROMINENT': 'PROMINENT'
                };
                var USE_CASE = {
                    'REUSE': 'REUSE',
                    'ACQUISITION': 'ACQUISITION'
                };
                var CREDIT_TYPE = {
                    'CORE': 'CORE',
                    'SAC': 'SAC',
                    'EZP': 'EZP'
                };

                var getDefaultBanner = function getDefaultBanner(bannerType, useCase, creditType, amount, termsLink) {
                    if (bannerType === BANNER_TYPES.PROMINENT) {
                        if (useCase === USE_CASE.ACQUISITION) {
                            if (creditType === CREDIT_TYPE.CORE) {
                                return {
                                    bodyText: $scope.htmlContent('offers.bmlOfferSmallTitleWithAmount', { cartAmount: amount }),
                                    ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
                                    termsText: $scope.htmlContent('offers.subjectToApproval'),
                                    termsLink: termsLink,
                                    termsLinkText: $scope.htmlContent('offers.seeTermsText')
                                };
                            } else if (creditType === CREDIT_TYPE.SAC) {
                                return {
                                    bodyText: $scope.htmlContent('offers.bmlOfferLargeTitleWithAmount', { cartAmount: amount }),
                                    ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
                                    termsText: $scope.htmlContent('offers.subjectToApproval'),
                                    termsLink: termsLink,
                                    termsLinkText: $scope.htmlContent('offers.seeTermsText')
                                };
                            } else if (creditType === CREDIT_TYPE.EZP) {
                                return {
                                    bodyText: $scope.htmlContent('offers.bmlOfferSmallTitleWithAmount', { cartAmount: amount }),
                                    ctaText: $scope.htmlContent('offers.bmlOfferBtn'),
                                    termsText: $scope.htmlContent('offers.subjectToApproval')
                                };
                            }
                        } else if (useCase === USE_CASE.REUSE) {
                            if (creditType === CREDIT_TYPE.CORE) {
                                return {
                                    bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
                                    bodyText2: $scope.htmlContent('offers.bmlExistingOfferSmall'),
                                    ctaText: $scope.htmlContent('offers.bmlOfferReuseCta'),
                                    termsLink: termsLink,
                                    termsLinkText: $scope.htmlContent('offers.seeTermsText')
                                };
                            } else if (creditType === CREDIT_TYPE.SAC) {
                                return {
                                    bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
                                    bodyText2: $scope.htmlContent('offers.bmlExistingOfferLarge'),
                                    ctaText: $scope.htmlContent('offers.bmlOfferReuseCta'),
                                    termsLink: termsLink,
                                    termsLinkText: $scope.htmlContent('offers.seeTermsText')
                                };
                            } else if (creditType === CREDIT_TYPE.EZP) {
                                return {
                                    bodyText: $scope.htmlContent('offers.bmlExistingOfferTitle'),
                                    bodyText2: $scope.htmlContent('offers.bmlExistingOfferSmall'),
                                    ctaText: $scope.htmlContent('offers.cycoOfferBtn')
                                };
                            }
                        }
                    } else if (useCase === USE_CASE.ACQUISITION) {
                        if (creditType === CREDIT_TYPE.CORE) {
                            return {
                                bodyText: $scope.htmlContent('offers.bmlOfferPassiveDetails', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferPassiveCta'),
                                termsText: $scope.htmlContent('offers.subjectToApproval'),
                                termsLink: termsLink,
                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
                            };
                        } else if (creditType === CREDIT_TYPE.SAC) {
                            return {
                                bodyText: $scope.htmlContent('offers.bmlOfferPassiveSACDetails', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferPassiveCta'),
                                termsText: $scope.htmlContent('offers.subjectToApproval'),
                                termsLink: termsLink,
                                termsLinkText: $scope.htmlContent('offers.seeTermsText')
                            };
                        } else if (creditType === CREDIT_TYPE.EZP) {
                            return {
                                bodyText: $scope.htmlContent('offers.bmlOfferPassiveDetails', { cartAmount: amount }),
                                ctaText: $scope.htmlContent('offers.bmlOfferPassiveEZPCta'),
                                termsText: $scope.htmlContent('offers.subjectToApproval')
                            };
                        }
                    }
                };

                var getReuseOfferInfo = function getReuseOfferInfo(creditType, termsLink, amount) {
                    if (creditType === CREDIT_TYPE.CORE) {
                        return {
                            bodyText: $scope.htmlContent('offers.bmlOfferPassiveDetails', { cartAmount: amount }) + '.',
                            termsLink: termsLink,
                            termsLinkText: $scope.htmlContent('offers.seeTermsText')
                        };
                    } else if (creditType === CREDIT_TYPE.SAC) {
                        return {
                            bodyText: $scope.htmlContent('offers.bmlOfferPassiveSACDetails', { cartAmount: amount }) + '.',
                            termsLink: termsLink,
                            termsLinkText: $scope.htmlContent('offers.seeTermsText')
                        };
                    } else if (creditType === CREDIT_TYPE.EZP) {
                        return {
                            bodyText: $scope.htmlContent('offers.bmlOfferPassiveDetails', { cartAmount: amount }) + '.'
                        };
                    }
                };

                $populate($scope, {
                    auth: $AuthModel.instance($scope.token),
                    checkoutSession: $CheckoutSessionModel.instance($scope.token),
                    checkoutCart: $CheckoutCartModel.instance($scope.token),
                    checkoutAppData: $CheckoutAppDataModel.instance($scope.token),
                    payee: $CheckoutPayeeModel.instance($scope.token)
                }).then(function () {
                    // pxp for banner ramp in UK
                    return $pxp('xo_hermes_cape_migration_UK', { 'ctx.COUNTRY': $locale.country }, 'xo_cape_migration_UK_test').then(function (result) {
                        if (result && result.treatment_name === 'xo_cape_migration_UK_test') {
                            $scope.isUKBannerEligible = true;
                        }
                    });
                }).then(function () {
                    // pxp for MORS ramp
                    $scope.isMorsPxpEnabled = false;
                    $scope.placementCode = '210004';
                    $scope.presentation_types = ['PayPalCreditCheckout'];
                    $scope.pu_type = 'PERSONAL';

                    return $pxp('xo_hermes_choice_1stbutton_phase2_ramp', { 'ctx.COUNTRY': $locale.country }, 'xo_hermes_choice_1stbutton_phase2_ramp_treatment').then(function (result) {
                        if (result && result.treatment_name === 'xo_hermes_choice_1stbutton_phase2_ramp_treatment') {
                            $scope.isMorsPxpEnabled = true;
                        }
                    });
                }).then(function () {
                    var morsCallFailed = false;

                    /** --------------------------------------------------
                     ** Populate credit offers and $scope.showBml
                     ** -------------------------------------------------- */
                    $scope.bmlOffer = $scope.checkoutSession.bmlOffer;
                    $logger.info('bmlOffer: ' + $scope.bmlOffer);
                    $scope.buyerCountry = $locale.country;
                    var isCoreSACEligible = $scope.bmlOffer === 1 || $scope.bmlOffer === 2;
                    var fundingInstruments = $scope.checkoutSession.get('fundingOptions.instruments');
                    isCreditInWallet = $util.find(fundingInstruments, function (fi) {
                        return fi.name === 'BILL_ME_LATER';
                    });
                    isRedirectFromCape = $CreditDataModel.instance($scope.token).isRedirectFromCape();

                    $scope.checkIfSelectFiDisplayedBanner = function (showBanner) {
                        var current = $state.current;


                        if (showBanner && current.name === 'checkout.selectFi') {
                            $rootScope.hideBanner = true;
                        } else if ($rootScope.hideBanner) {
                            showBanner = false;
                        }
                        return showBanner;
                    };

                    // Banner for US installments and for all banners in UK
                    var showBannerRules = function showBannerRules() {
                        if ($locale.country === 'GB') {
                            $scope.offerTypeKey = $scope.installmentOptionsPresent ? 'offers.bmlInstallmentTitle' : $scope.isBmlOfferSmallOrLarge(ACQ_Banner_Type);
                            // FPTI tracking
                            $logger.info('isUkBannerEligible ' + $scope.isUKBannerEligible);

                            if ($scope.isUKBannerEligible && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditOffer)) {
                                // UK banner eligible for credit test group
                                $logger.info('checkout_fpti', {
                                    'banner_type': 'test_ACQUISITION'
                                });
                            } else if (!$scope.isUKBannerEligible && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditOffer)) {
                                // UK banner eligible for credit control group (will not see banner)
                                $logger.info('checkout_fpti', {
                                    'banner_type': 'control_ACQUISITION'
                                });
                            }

                            if ($scope.showUKBanner && !isCreditInWallet && !isRedirectFromCape && (isCoreSACEligible || $scope.checkoutSession.creditOffer)) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return !isCreditInWallet && $scope.installmentOptionsPresent && !isRedirectFromCape;
                        }
                    };

                    // Logic to determine is CYCO is shown in reuse
                    var showCYCORules = function showCYCORules() {
                        var commonRules = isCreditInWallet && $scope.checkoutSession.creditOffer && $scope.installmentOptionsPresent;
                        if ($locale.country === 'GB') {
                            return $scope.showUKBanner && commonRules;
                        } else {
                            return commonRules;
                        }
                    };

                    /**
                     * This function is to determine that the offer is large offer (transaction amount >= 99) or
                     * smaller (transaction amount < 99) to display appropriate text on ui
                     * @returns bmlExistingSmall/LargeOffer
                     */
                    $scope.isBmlOfferSmallOrLarge = function (bannerType) {
                        var key = void 0;
                        if ($scope.isBmlOfferLarge()) {
                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferLargeTitle' : 'offers.bmlExistingOfferLarge';
                        } else {
                            key = bannerType === ACQ_Banner_Type ? 'offers.bmlOfferSmallTitle' : 'offers.bmlExistingOfferSmall';
                        }
                        return key;
                    };

                    // small refactor of isBmlOfferSmallOrLarge() function
                    $scope.isBmlOfferLarge = function () {
                        var transactionAmount = $scope.getTransactionAmount();
                        var sacEligibleAmount = $CreditOptionsModel.sacEligibleAmount[$locale.country];
                        return transactionAmount >= sacEligibleAmount;
                    };

                    $scope.getTransactionAmount = function () {
                        var transactionAmount = $scope.checkoutCart.get('purchase.amounts.total.amount');
                        return parseFloat(transactionAmount) || 0;
                    };

                    // override bmlOffer
                    if ($scope.buyerCountry === 'US') {
                        if ($scope.isBmlOfferLarge()) {
                            $scope.bmlOffer = 1;
                        } else {
                            $scope.bmlOffer = 2;
                        }

                        $scope.installment.bmlOffer = $scope.bmlOffer;
                    }

                    var executeSsotCall = function executeSsotCall(silent) {
                        if ($feature('creditInstallmentOffers') && $scope.checkoutAppData.merchant.merchant_country === $locale.country && !$scope.checkoutCart.isBilling()) {

                            var processInstallmentResponse = function processInstallmentResponse(result) {
                                $scope.creditOffers = result.installments && result.installments[0];
                                $scope.installmentCount = $scope.creditOffers && $scope.creditOffers.installment_options && $scope.creditOffers.installment_options.length;
                                $scope.installmentOptionsPresent = $scope.installment.installmentOptionsPresent = $scope.checkoutSession.creditOffer && $scope.installmentCount > 0;
                                $scope.showUKBanner = $scope.checkoutAppData.is_second_button_txn || $scope.isUKBannerEligible;

                                if ($scope.buyerCountry === 'US') {
                                    $scope.installment.showBanner = $scope.checkIfSelectFiDisplayedBanner(showBannerRules());
                                    $scope.installment.showWalletBanner = showBannerRules();
                                } else {
                                    $scope.installment.showBanner = showBannerRules();
                                }

                                $scope.installment.showCYCO = showCYCORules();
                                var hideSacBanner = $scope.installment.showBanner || isRedirectFromCape || $locale.country === 'GB';
                                $scope.showBml = hideSacBanner ? false : isCoreSACEligible;
                            };

                            // Cache the installment offer call to prevent duplicate calls in the same session
                            $rootScope.instCache = $rootScope.instCache || {};
                            var instCacheId = '' + $scope.checkoutSession.id;
                            var cachedInst = $rootScope.instCache[instCacheId];

                            if (cachedInst) {
                                return $q(function (resolve) {
                                    return resolve(processInstallmentResponse(cachedInst));
                                });
                            } else {
                                var offers = $InstallmentOptionsModel.instance($scope.token);
                                return offers.save({
                                    silent: silent,
                                    data: {
                                        payee: $scope.payee,
                                        checkoutCart: $scope.checkoutCart,
                                        checkoutAppData: $scope.checkoutAppData,
                                        isMemberCredit: true
                                    },
                                    success: function success(result) {
                                        processInstallmentResponse(result);
                                        $rootScope.instCache[instCacheId] = result;
                                    },
                                    contingencies: {
                                        DEFAULT: function DEFAULT() {
                                            $logger.info('GET_INSTALLMENT_CONTINGENCY');
                                        }
                                    }
                                });
                            }
                        } else {
                            return $q(function (resolve) {
                                var hideSacBanner = isRedirectFromCape || $locale.country === 'GB';
                                $scope.showBml = hideSacBanner ? false : isCoreSACEligible;
                                resolve();
                            });
                        }
                    };

                    /** --------------------------------------------------
                     ** Call MORS for banner
                     ** -------------------------------------------------- */

                    $scope.creditTerms = $config.urls.creditTerms;
                    $scope.creditReuseTerms = $config.urls.creditReuseTerms;

                    var mapResponseToBanner = function mapResponseToBanner(ad) {
                        var formatBannerField = function formatBannerField(content) {
                            if (angular.isString(content)) {
                                // Ensure "PayPal Credit" does not wrap
                                content = $sce.trustAsHtml(content.replace(/PayPal Credit/g, '<span class="nowrap">PayPal Credit</span>'));
                            }

                            return content;
                        };

                        var getMorsOfferType = function getMorsOfferType(offerType) {
                            if (offerType === 'CORE') {
                                return CREDIT_TYPE.CORE;
                            }
                            if (offerType === 'SAC') {
                                return CREDIT_TYPE.SAC;
                            }
                            if (offerType === 'PALA') {
                                return CREDIT_TYPE.EZP;
                            }
                            $logger.warn('unknown_credit_type');
                        };

                        $scope.showPassiveBanner = ad['MessageType'] !== 'Prominent';
                        $scope.banner.offerType = getMorsOfferType(ad['offertype']);

                        if (!$scope.showPassiveBanner) {
                            $scope.banner.bodyText = formatBannerField(ad['OfferText1']);
                            $scope.banner.bodyText2 = formatBannerField(ad['OfferText2']);
                            $scope.banner.logo = ad['Logo'];
                            $scope.banner.ctaText = formatBannerField(ad['CTAText']);
                            $scope.banner.termsText = formatBannerField(ad['TermsText']);
                            $scope.banner.termsLink = ad['TermsLink'];
                            $scope.banner.termsLinkText = ad['TermsLinkText'];
                        } else {
                            $scope.banner.ctaText = formatBannerField(ad['OfferText1']);
                            $scope.banner.bodyText = formatBannerField(ad['OfferText2']);
                            $scope.banner.logo = ad['Logo'];
                            $scope.banner.termsText = formatBannerField(ad['TermsText']);
                            $scope.banner.termsLink = ad['TermsLink'];
                            $scope.banner.termsLinkText = ad['TermsLinkText'];
                        }
                    };

                    var getCreditType = function getCreditType(bmlOffer, isInst) {
                        // Check if there is an offer already selected
                        var instModel = $CreditInstallmentModel.instance($scope.token);

                        if (instModel && instModel.creditType === CREDIT_TYPE.SAC) {
                            return CREDIT_TYPE.SAC;
                        } else if (isInst) {
                            return CREDIT_TYPE.EZP;
                        } else if (bmlOffer === 1) {
                            return CREDIT_TYPE.SAC;
                        } else if (bmlOffer === 2) {
                            return CREDIT_TYPE.CORE;
                        }
                        $logger.warn('unknown_credit_type');
                    };

                    var mapDefaultToBanner = function mapDefaultToBanner(creditReuseTerms, creditTerms) {
                        $scope.useFallbackBanner = true;
                        $scope.showPassiveBanner = !isCreditInWallet;

                        $scope.banner = getDefaultBanner($scope.showPassiveBanner ? BANNER_TYPES.PASSIVE : BANNER_TYPES.PROMINENT, isCreditInWallet ? USE_CASE.REUSE : USE_CASE.ACQUISITION, getCreditType($scope.bmlOffer, $scope.installmentOptionsPresent), $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', ''), isCreditInWallet ? creditReuseTerms : creditTerms);
                    };

                    var mapReuseText = function mapReuseText(creditReuseTerms) {
                        $scope.reuseOfferInfo = getReuseOfferInfo(getCreditType($scope.bmlOffer, $scope.installmentOptionsPresent), creditReuseTerms, $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', ''));
                    };

                    var shouldCallMors = $scope.isMorsPxpEnabled && $locale.country === 'US' && $locale.lang === 'en' && $scope.placementCode;

                    var executeMorsCall = function executeMorsCall(silent) {
                        $rootScope.MORS = $rootScope.MORS || {};
                        $scope.banner = {};
                        var morsCacheId = $scope.checkoutSession.id + '-' + $scope.placementCode + '-' + !!isCreditInWallet + '-' + getCreditType($scope.bmlOffer, $scope.installmentOptionsPresent);
                        var cachedAd = $rootScope.MORS[morsCacheId];

                        if (cachedAd !== undefined) {
                            return $q(function (resolve) {
                                if (cachedAd === null) {
                                    morsCallFailed = true;
                                    resolve(mapDefaultToBanner($scope.creditReuseTerms, $scope.creditTerms));
                                } else {
                                    $scope.ad = cachedAd;
                                    resolve(mapResponseToBanner(cachedAd));
                                }
                            });
                        } else {
                            // Get wallet instruments
                            var walletInstruments = [];

                            if (isCreditInWallet) {
                                walletInstruments.push({
                                    financial_instrument_type: 'FI_PAYPAL_CREDIT',
                                    financial_instrument_product_type: 'PI_TYPE_CREDIT_TXN_CARD_BML',
                                    preferred: isCreditInWallet.isPreferred,
                                    out_of_wallet: false
                                });
                            }

                            $scope.marketingOfferModel = new $MarketingOfferModel({
                                countryCode: $locale.country,
                                page: 'HERMES_RYI_PAGE',
                                site: 'HERMES_RYI_PAGE',
                                puType: $scope.pu_type,
                                locale: $locale.lang + '_' + $locale.country,
                                totalTransactionAmount: {
                                    'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                                    'value': $scope.checkoutCart.get('purchase.amounts.total.amount', 0) * 100
                                },
                                totalShippingAmount: {
                                    'currency_code': $scope.checkoutCart.get('purchase.amounts.total.currency_code', ''),
                                    'value': $scope.checkoutCart.get('purchase.amounts.shipping.amount', 0) * 100
                                },
                                payee: $scope.payee.merchant.id || '',
                                payer: $scope.checkoutSession.payer.id || '',
                                si: $scope.checkoutSession.id || '',
                                targetPlacements: [{
                                    'placement_code': $scope.placementCode,
                                    'presentation_types': $scope.presentation_types
                                }],
                                walletInstruments: walletInstruments,
                                installmentsNotAllowed: !$scope.checkoutSession.creditOffer
                            });

                            return $MarketingOfferModel.instance($scope.token).save({
                                silent: silent,
                                data: $scope.marketingOfferModel.serialize(),
                                success: function success(result) {
                                    $logger.info('MORS_response', result);
                                    var ads_arr = result && result.ads || [];
                                    var adFound = false;

                                    // MORS could serve multiple ads for a given page. Iterate to get the
                                    // correct one based on the ad placement_id
                                    ads_arr.forEach(function (ad) {
                                        var adunit_id = ad.campaign.adunit_id;

                                        if (adunit_id.toString() === $scope.placementCode.toString() && ad.valid) {
                                            adFound = true;
                                            $scope.ad = {};
                                            var content = ad.content.nvp;
                                            content.forEach(function (obj) {
                                                $scope.ad[obj.name] = obj.value;
                                            });
                                            $scope.ad['impressionUrl'] = ad.tracking.impression_url;
                                            $scope.ad['clickUrl'] = ad.tracking.click_url;
                                            $scope.ad['campaignId'] = ad.campaign.campaign_id;
                                        }
                                    });
                                    if (adFound) {
                                        mapResponseToBanner($scope.ad);

                                        // Cache ad
                                        $rootScope.MORS[morsCacheId] = $scope.ad;
                                    } else {
                                        $logger.info('MORS_ad_not_found_credit');
                                        $rootScope.$broadcast('MORSNotDisplayed');
                                        $rootScope.MORS[morsCacheId] = null;
                                        morsCallFailed = true;
                                    }
                                },

                                error: function error(err) {
                                    $logger.error('MORS_api_failure_credit', { error: err });
                                    $rootScope.MORS[morsCacheId] = null;
                                    morsCallFailed = true;
                                }
                            });
                        }
                    };

                    // Don't make SSOT call if MORS is being called, unless it fails
                    if (shouldCallMors) {
                        return executeMorsCall(true)['finally'](function () {
                            if (morsCallFailed) {
                                return executeSsotCall(true).then(function () {
                                    mapReuseText($scope.creditReuseTerms);
                                    mapDefaultToBanner($scope.creditReuseTerms, $scope.creditTerms);
                                });
                            } else {
                                // Process installment response separately
                                $scope.showBml = !isRedirectFromCape && isCoreSACEligible;

                                $scope.installmentOptionsPresent = $scope.installment.installmentOptionsPresent = $scope.banner.offerType === CREDIT_TYPE.EZP;
                                var showInstBanner = $scope.installmentOptionsPresent && !isCreditInWallet && !isRedirectFromCape;
                                $scope.installment.showBanner = $scope.checkIfSelectFiDisplayedBanner(showInstBanner);
                                $scope.installment.showWalletBanner = showInstBanner;
                                $scope.installment.showCYCO = isCreditInWallet && $scope.checkoutSession.creditOffer && $scope.banner.offerType === CREDIT_TYPE.EZP;

                                mapReuseText($scope.creditReuseTerms);
                            }
                        });
                    } else {
                        return executeSsotCall(false);
                    }
                }).then(function () {
                    var fpIsCreditInWallet = $scope.checkoutSession.get('futurePayment.isCreditInWallet');

                    $scope.selectExistingBml = function () {
                        if ($scope.isMorsPxpEnabled && $scope.ad) {
                            $fireMORSBeacon.fireBeacon($scope.ad.clickUrl);
                        }

                        if ($scope.checkoutCart.isBillingNoPurchase()) {
                            var fpList = $scope.checkoutSession.get('futurePaymentInstruments');
                            var bml = fpList.find(function (fp) {
                                return fp.type === 'BILL_ME_LATER';
                            });

                            $scope.checkoutSession.action('setStickyFI', {
                                data: {
                                    instrument_id: bml.instrument_id
                                },
                                success: function success(result) {
                                    $scope.checkoutSession.message = {
                                        type: 'success',
                                        msgKeys: ['paymentMethod.paymentMethodUpdated']
                                    };
                                    $state.go('checkout.review');
                                }
                            });
                        } else {
                            var fiList = $scope.checkoutSession.get('fundingOptions.instruments');
                            var fundingSource = $util.find(fiList, function (fi) {
                                return fi.name === 'BILL_ME_LATER';
                            });

                            $scope.checkoutSession.fundingOptions.action('select', {
                                resultModel: $scope.checkoutSession,
                                data: {
                                    planId: fundingSource.planId
                                },
                                success: function success(result) {
                                    // Update selectedmethod if provided, to reflect in multipleFi on RYI choice variant
                                    if ($scope.selectedmethod) {
                                        $scope.selectedmethod.index = 0;
                                        $scope.selectedmethod.planId = $scope.checkoutSession.get('plan.sources')[0].id;
                                    }

                                    if (result) {
                                        // Update the installments to support the user selecting a card that does not support installments.
                                        $scope.checkoutSession.installments = result.installments;
                                    }
                                    if (fundingSource.type === 'CREDIT' && $scope.installment.showCYCO) {
                                        $state.go('checkout.chooseCreditOffer');
                                    } else {
                                        if (!fundingSource.selected) {
                                            $scope.checkoutSession.message = {
                                                type: 'success',
                                                msgKeys: ['paymentMethod.paymentMethodUpdated']
                                            };
                                            if ($scope.checkoutSession.selectedInstallmentData && !$scope.checkoutSession.selectedInstallmentData.preventChange) {
                                                // Resetting selected installment data, if installment change is not explicitly prohibited.
                                                $scope.checkoutSession.selectedInstallmentData = undefined;
                                            }
                                        }
                                        $state.go('checkout.review');
                                    }
                                }
                            });
                        }
                    };

                    $scope.getBmlOfferTitle = function (suffix, data) {
                        if ($scope.bmlOffer === 1) {
                            return $scope.htmlContent('offers.bmlOfferLargeTitle' + suffix, data);
                        } else if ($scope.bmlOffer === 2) {
                            return $scope.htmlContent('offers.bmlOfferSmallTitle' + suffix, data);
                        } else {
                            return '';
                        }
                    };

                    if ($scope.buyerCountry === 'US') {
                        $scope.bmlOfferTitle = $scope.getTransactionAmount() === 0 ? $scope.htmlContent('offers.bmlOfferTitleWithAmountZero') : $scope.getBmlOfferTitle('WithAmount', {
                            cartAmount: $scope.checkoutCart.get('purchase.amounts.total.amount_formatted', '')
                        });

                        // US766704: for use in xo-wallet
                        $scope.installment.bmlOfferTitle = $scope.bmlOfferTitle;
                    }

                    $scope.showAcquisitionBanner = function () {
                        var showBanner = void 0;

                        showBanner = $scope.showBml && $scope.buyerCountry !== 'GB';

                        // Combine acquisition banner and installment banner logic
                        // TODO: Refactor all of this after control is removed - there needs to be clear separation between
                        // countries, and installment acquisition banner logic should be in this function
                        if ($scope.isMorsPxpEnabled) {
                            showBanner = showBanner || $scope.installment.showBanner;
                        }

                        showBanner = $scope.checkIfSelectFiDisplayedBanner(showBanner);

                        if (!$scope.usCreditBannerFptiFired && showBanner && $scope.isMorsPxpEnabled && $scope.banner && $scope.buyerCountry === 'US') {
                            $scope.usCreditBannerFptiFired = true;

                            if ($scope.ad) {
                                $logger.info('checkout_fpti', {
                                    'banner_type': USE_CASE.ACQUISITION + '_' + $scope.ad['MessageType'] + '_MORS',
                                    'caid': $scope.ad['campaignId']
                                });
                                $logger.info('MORS_ad_displayed_credit_' + USE_CASE.ACQUISITION + '_' + $scope.ad['MessageType']);

                                $fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);

                                $rootScope.$broadcast('MORSDisplayed', {
                                    clickUrl: $scope.ad.clickUrl,
                                    placementId: $scope.placementCode
                                });
                            } else {
                                $logger.info('checkout_fpti', {
                                    'banner_type': USE_CASE.ACQUISITION + '_' + BANNER_TYPES.PASSIVE + '_MORSfallback'
                                });
                                $logger.info('MORS_fallback_ad_displayed_credit_' + USE_CASE.ACQUISITION + '_' + BANNER_TYPES.PASSIVE);
                            }
                        }

                        return showBanner;
                    };

                    /**
                     * Only show PPC Reuse banner if
                     * Country is US & Credit is not default AND There is credit in wallet AND pxp variant has banner
                     **/
                    $scope.showReuseBanner = function () {
                        var showBanner = false;
                        var reuseRules = true;
                        if ($scope.checkoutCart.isBillingNoPurchase()) {
                            var stickyFi = $scope.checkoutSession.getSelectedStickyInstrument();
                            reuseRules = fpIsCreditInWallet && !(stickyFi.type === 'BILL_ME_LATER');
                        } else {
                            $scope.isCreditDefault = $scope.checkoutSession.get('plan.paypal_credit');
                            reuseRules = isCreditInWallet && !$scope.isCreditDefault;
                        }
                        $scope.installment.showRepresentativeInfo = $scope.showUKBanner && $locale.country === 'GB' && (reuseRules || $scope.installment.showBanner);
                        $scope.showPPCLogo = true;

                        // FPTI tracking
                        if (!$scope.fptiTrigger) {
                            if ($scope.isUKBannerEligible && $locale.country === 'GB' && reuseRules) {
                                // UK reuse banner eligible for credit test group (will see banner)
                                $logger.info('checkout_fpti', {
                                    'banner_type': 'test_REUSE'
                                });
                                $scope.fptiTrigger = true;
                            } else if (!$scope.isUKBannerEligible && $locale.country === 'GB' && reuseRules) {
                                // UK reuse banner eligible for credit control (will not see banner)
                                $logger.info('checkout_fpti', {
                                    'banner_type': 'control_REUSE'
                                });
                                $scope.fptiTrigger = true;
                            }
                        }

                        if ($locale.country === 'US' && reuseRules && !(isRedirectFromCape && isCreditInWallet)) {
                            showBanner = true;
                        } else if ($scope.showUKBanner && $locale.country === 'GB' && reuseRules) {
                            $scope.reuseOfferTypeKey = $scope.installmentOptionsPresent ? 'offers.bmlExistingOfferInstallment' : $scope.isBmlOfferSmallOrLarge();
                            return true;
                        }
                        showBanner = $scope.checkIfSelectFiDisplayedBanner(showBanner);

                        if (!$scope.usCreditBannerFptiFired && showBanner && $scope.isMorsPxpEnabled && $scope.banner && $scope.buyerCountry === 'US') {
                            $scope.usCreditBannerFptiFired = true;

                            if ($scope.ad) {
                                $logger.info('checkout_fpti', {
                                    'banner_type': USE_CASE.REUSE + '_' + $scope.ad['MessageType'] + '_MORS',
                                    'caid': $scope.ad['campaignId']
                                });
                                $logger.info('MORS_ad_displayed_credit_' + USE_CASE.REUSE + '_' + $scope.ad['MessageType']);

                                $fireMORSBeacon.fireBeacon($scope.ad.impressionUrl);

                                $rootScope.$broadcast('MORSDisplayed', {
                                    clickUrl: $scope.ad.clickUrl,
                                    placementId: $scope.placementCode
                                });
                            } else {
                                $logger.info('checkout_fpti', {
                                    'banner_type': USE_CASE.REUSE + '_' + BANNER_TYPES.PASSIVE + '_MORSfallback'
                                });
                                $logger.info('MORS_fallback_ad_displayed_credit_' + USE_CASE.REUSE + '_' + BANNER_TYPES.PASSIVE);
                            }
                        }

                        return showBanner;
                    };

                    $scope.bml = function () {
                        if ($scope.isMorsPxpEnabled) {
                            // TODO: Deprecate creditOffer() - installment should not be a different banner
                            if ($scope.ad) {
                                $fireMORSBeacon.fireBeacon($scope.ad.clickUrl);
                            }

                            if ($scope.installment.showBanner) {
                                $state.go('checkout.chooseCreditOffer');
                            } else {
                                $state.go('checkout.redirectToCape');
                            }
                        } else {
                            $state.go('checkout.redirectToCape');
                        }
                    };

                    $scope.creditOffer = function () {
                        $state.go('checkout.chooseCreditOffer');
                    };

                    $scope.addPlcc = function () {
                        $scope.promotion.type = 'plcc';
                        $state.go('checkout.review.sidebar.sidebarAddCard.addCardFlow.addCard');
                    };

                    $scope.showPlcc = $scope.checkoutSession.plccOffer;
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/offer/directive.js
// module id = ./components/xo-credit-components/src/offer/directive.js
// module chunks = 1